import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { motion } from 'framer-motion';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthVerify() {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { login } = useAuth();
    const [status, setStatus] = useState('verifying');

    useEffect(() => {
        const token = searchParams.get('token');
        const redirect = searchParams.get('redirect') || '/dashboard';
        if (!token) {
            setStatus('error');
            return;
        }

        axios.post(`${API}/auth/verify`, { token })
            .then(res => {
                login(res.data.access_token, res.data.user);
                setStatus('success');
                setTimeout(() => navigate(redirect), 1200);
            })
            .catch(() => {
                setStatus('error');
            });
    }, []);

    return (
        <div className="min-h-screen bg-accent flex items-center justify-center px-4">
            <motion.div
                initial={{ opacity: 0, scale: 0.95 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 0.4 }}
                className="card-base p-10 max-w-sm w-full text-center"
            >
                {status === 'verifying' && (
                    <>
                        <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-6" />
                        <h2 className="heading-sm text-foreground mb-2">Verifying your link...</h2>
                        <p className="text-muted-foreground text-sm">Please wait a moment.</p>
                    </>
                )}
                {status === 'success' && (
                    <>
                        <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <span className="text-2xl">✓</span>
                        </div>
                        <h2 className="heading-sm text-foreground mb-2">Logged in!</h2>
                        <p className="text-muted-foreground text-sm">Redirecting to your dashboard...</p>
                    </>
                )}
                {status === 'error' && (
                    <>
                        <div className="w-12 h-12 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
                            <span className="text-2xl">✗</span>
                        </div>
                        <h2 className="heading-sm text-foreground mb-2">Link expired or invalid</h2>
                        <p className="text-muted-foreground text-sm mb-6">This login link may have expired or already been used.</p>
                        <a href="/login" className="btn-secondary text-sm px-6 py-2.5">
                            Try again
                        </a>
                    </>
                )}
            </motion.div>
        </div>
    );
}
